import { Path } from "~/v2/path";
import type {
  AccountStatusMapFunction,
  AccountStatusProps,
} from "./AccountStatusMap";
import { ApprovalPending } from "./ApprovalPending";

export const Submitted = ({
  account,
  isLegalEntity,
}: AccountStatusProps): ReturnType<AccountStatusMapFunction> => {
  if (account?.account_type === "ira") {
    return {
      message:
        "Your IRA account is being reviewed. We'll let you know when it's ready!",
      badge: {
        title: "In-Review",
        variant: "v2/orange",
      },
    };
  }

  if (isLegalEntity) {
    return {
      title: "Application received!",
      message: "Please allow 3-5 Business days for manual review.",
    };
  }

  const isOnboardingCompleted = account?.last_onboarding_step === "finished";

  if (isOnboardingCompleted) {
    return ApprovalPending();
  }

  return {
    message: "Complete your application",
    button: {
      text: "Complete Verification",
      to: Path.ROUTE_NEW_ACCOUNT,
    },
  };
};
